/**
 * @fileOverview Defines the most important client library that can connect an app with forge powered blockchain: {@link GraphQLClient}
 *
 * GraphQLClient can be used both in node.js or in the browser, if you are looking for a client library for backend javascript applications, please checkout {@link GRpcClient}
 *
 * @module @ocap/client
 * @requires @ocap/proto
 * @requires @ocap/wallet
 * @requires @ocap/message
 * @requires @ocap/util
 * @see GraphQLClient
 * @see GRpcClient
 * @example
 * bun add @ocap/client
 * npm i @ocap/client -S
 */
